import type { Provider } from '@angular/core';
import { DefaultLocale } from '@app/+authenticated/shared/locale/locale.helper';
import { ApiGatewayGlobalOptions } from '@sb/shared/api';
import { environment } from 'src/environments/environment';

export const provideApiGatewayOptions = (): Provider => ({
  provide: ApiGatewayGlobalOptions,
  useFactory: () => ({
    version: environment.version,
    getLocale: () => localStorage.getItem('locale') ?? DefaultLocale,
  }),
});
